const Footer = () => {
  return (
    <div className="text-center mb-5">
      <p>&copy; Tripify 2022</p>
      <p className="mb-5 pb-5">All Rights Reserved</p>
    </div>
  );
};

export default Footer;
